import { useSelector } from 'react-redux';
import { scrollToResponses } from 'src/utils/scroll';
import {pluralize} from 'src/utils/string';
import signupContext from 'src/constants/signupContext';
import i18n from 'src/utils/translate';
import Badges from 'src/components/badges/badges';
import RelativeTime from 'src/components/relativeTime';
import UserLink from 'src/modules/shared/links/userLink';
import { State } from 'src/types';
import { useIsCommunityMember } from 'src/utils/context';
import styled from 'styled-components';
import { textLight, titleSmall } from 'styles-js/mixins/typography';
import Icon from 'src/components/icon';
import { Fragment } from 'react';

export default function PostHeaderInfo() {
  const { post } = useSelector(({pages}: State) => pages.singlePost);
  const { currentUser } = useSelector(({context}: State) => context);
  const isCommunityMember = useIsCommunityMember();


  if (post.isPrivate && !isCommunityMember) {
    return (
      <InfoSection>
        <RelativeTime rawTime={post.dateCreated} />
        <Separator>•</Separator>
        <Replies total={post.totalResponses} />
      </InfoSection>
    );
  }

  return (
    <Fragment>
      <UserLink
        avatar={true}
        avatarSize="small"
        className="userlink-avatar-link"
        isLoggedIn={!!currentUser}
        signupContext={{
          element: signupContext.element.AVATAR,
          section: signupContext.section.POST,
        }}
        user={post.author}
      />
      <Info>
        <InfoSection>
          <UserLink
            avatar={false}
            className="author"
            isLoggedIn={!!currentUser}
            signupContext={{
              element: signupContext.element.USER_LINK,
              section: signupContext.section.POST,
            }}
            user={post.author}
          />
          {post?.author?.roles?.length > 0 && <Badges roles={post.author.roles}/>}
          <Separator className="hidden-sm">•</Separator>
        </InfoSection>
        <InfoSection>
          <RelativeTime rawTime={post.dateCreated} />
          <Separator>•</Separator>
          <Replies total={post.totalResponses} />
          {post.isPrivate && <Icon icon="lock"/>}
        </InfoSection>
      </Info>
    </Fragment>
  );
}

const Replies = ({total = 0}: {total: number}) => (
  <a href="#post-responses" onClick={e => {e.preventDefault(); scrollToResponses();}}>
    {pluralize(i18n.t('%1$s Reply'), i18n.t('%1$s Replies'), total)}
  </a>
);

const Info = styled.div`
  display: inline-flex;
  vertical-align: middle;
  margin-left: 12px;
  @media (${({theme}) => theme.underScreenMedium}) {
    flex-direction: column;
  }
`;

const InfoSection = styled.div`
  ${textLight}
  > * {
    margin-right: 12px;
  }
  .author {
    ${titleSmall}
  }
  a {
    ${textLight}
  }
`;

const Separator = styled.span`
  color: ${({theme}) => theme.colorGreyDark};
`;
